import $ from 'jquery';
import { MQ } from '../tools/MQ';

export const init = () => {
	const $jsPriceToggle = $('.js-price-toggle');
	const $jsPriceFilter = $('.js-price-filter');

	function togglePriceSlide(event) {
		event.preventDefault();
		$jsPriceToggle.toggleClass('is-open');
		if ($jsPriceToggle.hasClass('is-open')) {
			$jsPriceToggle.attr('aria-expanded', true);
		} else {
			$jsPriceToggle.attr('aria-expanded', false);
		}
		$jsPriceFilter.toggleClass('is-active');
		$jsPriceFilter.slideToggle();
	}

	if (MQ('lgUp')) {
		$jsPriceToggle.removeAttr('aria-expanded');
	} else if (MQ('mdDown')) {
		$jsPriceToggle.attr('aria-expanded', false);
	}

	$jsPriceToggle.on('click', togglePriceSlide);

	$(window).on('resize', () => {
		if (MQ('mdUp') && $jsPriceFilter.attr('style')) {
			$jsPriceFilter.removeAttr('style');
		}
		if (MQ('mdUp') && $jsPriceFilter.hasClass('is-active')) {
			$jsPriceFilter.removeClass('is-active');
		}
		if (MQ('mdUp') && $jsPriceToggle.hasClass('is-open')) {
			$jsPriceToggle.removeClass('is-open');
			$jsPriceToggle.attr('aria-expanded', false);
		}
	});
};
